export const LightTheme = {

    body:"#FCF6F4",
    text:"#2E0909",
    fontFamily:"'Source Sans Pro', sans-serif",
    bodyRgba : "252, 246, 244",
    textRgba:"46,9,9",
}

export const DarkTheme = {
    body:"#2E0909",
    text:"#FCF6F4",
    fontFamily:"'Source Sans Pro', sans-serif",
    textRgba : "252, 246, 244",
    bodyRgba:"46,9,9",
}